import { Component, OnInit } from '@angular/core';
import { EnvironmentService } from '../../services/environment.service';
import { AuthService } from '../../../auth/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {

  constructor(private envService: EnvironmentService,
    private authService: AuthService) { }

  ngOnInit() {

  }

  /**
   * Purpose: For loading Landing / home Header based on User Logged in
   */
  public isUserLoggedIn(): boolean {
    return this.authService.isUserLoggedIn();
  }
}



// WEBPACK FOOTER //
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/core/modules/header/header.component.ts